import { TDashboardItemsSet } from "~/ui-rtk/constants/dashboard"
import useSources from "~/ui-rtk/hooks/sources"
import { getContentWidgetIds } from "~/ui-rtk/utils/content"
import { useVisualizationsMap } from "~/ui-rtk/hooks/visualizations"
import { brandRoutes } from "~/ui-rtk/constants/routes"

export const content = {
  id: "shopify-orders",
  slug: brandRoutes.REVENUE.SHOPIFY_ORDERS,
  icon: null,
  title: "Shopify Orders",
  parent: {
    slug: brandRoutes.REVENUE.ROOT,
    title: "Revenue",
  },
  metadata: {
    visibleToRoles: ["SUPER_ADMIN"],
  },
  order: 1.95,
  content: {
    items: [
      {
        className: "h-120",
        grid: 1,
        items: [
          {
            widget: "shopify_orders_economics_chart",
          },
        ],
      },
      {
        className: "h-10",
        grid: 1,
        items: [
          {
            widget: "SPACER",
          },
        ],
      },
      {
        className: "min-h-40",
        grid: 1,
        items: [
          {
            widget: "shopify_orders_by_channel_table",
          },
        ],
      },
    ],
    title: "Shopify Orders",
    periodPicker: {
      visible: true,
    },
    commonGranularityPicker: true,
  },
  items: [],
}

export default function useConnect() {
  const { sources, isLoading: isSourcesDataLoading } = useSources()

  const widgetIds = getContentWidgetIds(
    content.content.items as TDashboardItemsSet,
  )
  const { visualizations } = useVisualizationsMap(widgetIds)

  const props = {
    commonGranularityPicker: content.content.commonGranularityPicker,
  }

  return {
    content,
    sources,
    visualizations,
    props,
    isLoading: isSourcesDataLoading,
  }
}
